import React, { FC }            from 'react';
import styled                   from 'styled-components';
import CheckIcon                from '@material-ui/icons/Check';
import { Divider, Grid }        from '@material-ui/core';
import { CarFaxBlock }          from '@modules/accountManagement/components/CarFaxBlock';
import {
  ICarFaxUser,
  ICreditUnion,
  IPartners,
}                               from '@typings/accountManagement';
import { EConnectServiceState } from '@enums/accountManagement';
import { PARTNERS_TITLE }       from '@modules/accountManagement/utils/suggestions';
import { AccountPageWrapper }   from '@modules/accountManagement/components/AccountPageWrapper';
import { ReindeerBlock }        from '@modules/accountManagement/components/ReindeerBlock';

interface IStyledProps {
  status: boolean;
}

const Wrapper = styled.div`
  padding: 40px 10px;
`;

const StatusWrapper = styled.div`
  display     : flex;
  align-items : center;
`;

const CheckIconWrap = styled.span<IStyledProps>`
  & svg {
    fill: ${({ status, theme: { textColor } }): string => status && textColor.green};
  }
`;

const LabelWrapper = styled.span`
  padding     : 5px;
  font-weight : 500;
`;

const AccountNumberWrapper = styled.span`
  color: #707070;
`;

interface IProps {
  partners              : IPartners;
  isLoading             : boolean;
  carFaxAuthState       : boolean;
  accountData           : ICreditUnion;
  reindeerState         : EConnectServiceState;
  reindeerBtnLabel      : string;
  isLoadingReindeer     : boolean;
  authorizeToCarFax     : (payload: ICarFaxUser) => Promise<void>;
  unauthorizeFromCarFax : () => Promise<void>;
  push                  : (path: string) => void;
  onReindeerAuthClick   : (cuid: string) => Promise<void>;
}

export const AccountPartnersPage: FC<IProps> = ({
  partners,
  isLoading,
  carFaxAuthState,
  accountData,
  reindeerState,
  reindeerBtnLabel,
  isLoadingReindeer,
  authorizeToCarFax,
  unauthorizeFromCarFax,
  push,
  onReindeerAuthClick,
}) => (
  <AccountPageWrapper
    push   = {push}
    cuInfo = {accountData}
  >
    <Wrapper>
      <CarFaxBlock
        authorizeToCarFax     = {authorizeToCarFax}
        unauthorizeFromCarFax = {unauthorizeFromCarFax}
        isLoading             = {isLoading}
        isAuthorized          = {carFaxAuthState}
      />
    </Wrapper>

    <Divider />

    {reindeerState !== EConnectServiceState.Removed && (
      <>
        <Wrapper>
          <ReindeerBlock
            reindeerBtnLabel    = {reindeerBtnLabel}
            isLoadingReindeer   = {isLoadingReindeer}
            onReindeerAuthClick = {onReindeerAuthClick}
          />
        </Wrapper>

        <Divider />
      </>
    )}

    <Wrapper>
      {partners.map((partner) => (
        <Grid
          key={partner.type}
          spacing={2}
          alignItems="center"
          container
        >
          <Grid item xs={12} md={4}>
            <LabelWrapper>{PARTNERS_TITLE[partner.type]}</LabelWrapper>
          </Grid>

          <Grid item xs={12} md={2}>
            <StatusWrapper>
              <CheckIconWrap status={partner.state}>
                <CheckIcon color="disabled" />
              </CheckIconWrap>

              <LabelWrapper>{partner.state ? 'Active' : 'Inactive'}</LabelWrapper>

            </StatusWrapper>
          </Grid>

          <Grid item xs={12} md={6}>
            <LabelWrapper>Account # </LabelWrapper>

            {partner.state && !!partner.accName ? (
              <AccountNumberWrapper>{partner.accName}</AccountNumberWrapper>
            ) : '—'}
          </Grid>

        </Grid>
      ))}
    </Wrapper>
  </AccountPageWrapper>
);
